import styled from 'styled-components';
import { Card, Button } from 'antd';

export const ListContainer = styled.div`
  padding: 24px;
  background: #f5f5f5;
  min-height: calc(100vh - 64px);

  h1 {
    font-size: 28px;
    font-weight: 600;
    color: #262626;
    margin: 0;
  }
`;

export const FilterCard = styled(Card)`
  margin-bottom: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  border: none;

  .ant-card-body {
    padding: 20px;
  }
`;

export const ActionButton = styled(Button)`
  border: none;
  box-shadow: none;
  padding: 4px 8px;
  height: auto;
  
  &:hover {
    background-color: #f5f5f5;
  }
`;

export const ExpandedCard = styled.div`
  background: #fafafa;
  padding: 16px;
  border-radius: 8px;
  margin: 8px 0;
  border-left: 3px solid #1890ff;

  h4 {
    margin: 0 0 12px 0;
    color: #262626;
    font-size: 14px;
    font-weight: 600;
  }

  h5 {
    margin: 8px 0 4px 0;
    color: #595959;
    font-size: 12px;
    font-weight: 500;
  }

  .ant-descriptions-item-label {
    font-weight: 500;
    color: #595959;
    font-size: 12px;
  }

  .ant-descriptions-item-content {
    font-size: 12px;
    color: #262626;
  }
`;

export const WorkflowSection = styled.div`
  background: white;
  padding: 12px;
  border-radius: 6px;
  border: 1px solid #f0f0f0;

  .ant-steps-item-title {
    font-size: 12px !important;
  }

  .ant-steps-item-description {
    font-size: 11px !important;
  }
`;